/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ControllerViewModel } from "../types/ControllerViewModel.ts";

export const controllerViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do controller.")),
  name: z.string().describe("Nome do controller.").nullish(),
}) as unknown as ToZod<ControllerViewModel>;
